import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { getApiTargetInfo, getEnvConfig } from 'core/selectors'
import { Title, Content, FullHeightSizer } from 'core/screen-util'
import { Input, DatePicker, Checkbox } from 'antd'
// import { DatePickerContext } from 'context'
import moment from 'moment'
import styled from '@emotion/styled'

const DateLabel = styled.div`
  font-size: 1em;
  color: #777;
  margin-left: 1em;
  display: grid;
  justify-content: end;
  align-content: center;
  font-weight: 600;
`

const EventDuraCalculator = _ => {
  const [eventStart, setEventStart] = useState(moment())
  const [eventEnd, setEventEnd] = useState(moment().add(1, 'days'))
  const [showDLS, setShowDLS] = useState(false)
  const [result, setResult] = useState()

  useEffect(
    _ => {
      if (showDLS) {
        const val = parseFloat(
          eventEnd.diff(eventStart, 'hours', true)
        ).toFixed(2)
        setResult(val)
      } else {
        let ne = eventEnd.clone()
        ne = ne.utcOffset(0, true)
        let ns = eventStart.clone()
        ns = ns.utcOffset(0, true)
        const val = parseFloat(ne.diff(ns, 'hours', true)).toFixed(2)
        setResult(val)
      }
    },
    [eventEnd, eventStart, showDLS]
  )

  return (
    <FullHeightSizer heightOffset={300}>
      {({ height }) => (
        <Content
          style={{
            height: height - 20,
            marginTop: '30px',
          }}
        >
          <Title
            style={{
              display: 'grid',
              justifyContent: 'center',
              marginTop: '30px',
            }}
          >
            <span>
              <span>
                <b>Event Duration Calculator</b>
              </span>
            </span>
          </Title>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr',
              justifyItems: 'center',
            }}
          >
            <div
              style={{
                display: 'grid',
                marginLeft: '15px',
                gridGap: '20px',
                // gridTemplateColumns: '350px 450px',
                marginTop: '30px',
                justifyContent: 'center',
                gridTemplateColumns: '1fr 1fr',
                // maxWidth: '500px',
                alignSelf: 'center',
              }}
            >
              <DateLabel>Event Start :</DateLabel>

              <DatePicker
                showTime={{
                  format: 'HH:mm',
                }}
                format="MM/DD/YYYY HH:mm"
                placeholder="Select Start DateTime"
                value={eventStart}
                onChange={setEventStart}
                allowClear={false}
              />

              <DateLabel>Event End :</DateLabel>

              <DatePicker
                showTime={{ format: 'HH:mm' }}
                format="MM/DD/YYYY HH:mm"
                placeholder="Select End DateTime"
                onChange={setEventEnd}
                value={eventEnd}
                allowClear={false}
              />
              <div />
              <div style={{ display: 'grid', justifyContent: 'left' }}>
                <Checkbox
                  style={{
                    // display: 'flex',
                    justifyContent: 'right',
                    alignContent: 'flex-end',
                  }}
                  checked={showDLS}
                  onChange={e => setShowDLS(e.target.checked)}
                >
                  DaylightSavings
                </Checkbox>
              </div>
              <DateLabel>Duration in Hours :</DateLabel>
              <Input value={result} placeholder="Duration Hour" />
            </div>
          </div>
        </Content>
      )}
    </FullHeightSizer>
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
})

export default connect(mapStateToProps)(EventDuraCalculator)
